import React, {
    Component
} from 'react';
import {
    domainUrl
} from '../../config/Config';
import {
    UserId,
    Username
} from '../../helpers/User';
import * as Common from '../../helpers/Common';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getLearningRoom} from '../../actions/learningRoomAction';
const $ = window.$;

class Contentproceed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            LearningCompletedStatus: [],
            proceedStatus: 0
        };
    }
    getLearningCompletedStatus() {

        const {data} = this.props;
        Common.reactLoader("show", "Please wait...");
        let query_data = Common.objToSlashString({
            learner_id: UserId(),
            compseq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            dlr_id: data.dlr_id
        });
        fetch(domainUrl + 'learner-component-status/view' + query_data + '?expand=completed_date', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            }
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status == 1) {
                this.setState({
                    LearningCompletedStatus: responseJson.data
                });
            }
            Common.reactLoader("hide");
        });
    }
    continueTocomponentList() {
        this.props.backToComponentList();
    }
    proceed() {

        const {data} = this.props;

        let query_data = {
            comp_id: data.id,
            learner_id: UserId(),
            compseq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            divider_id: data.divider_id,
            dlrid: data.dlr_id,
            ag: (data.is_ag != "") ? data.ag_id : ""
        };

        window.swal({
           // title: 'Attention!',
            text: 'Proceed?',
            //type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#14a430',
            cancelButtonColor: '#0082c9',
            animation: false,
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result) {
                Common.reactLoader("show", "Please wait...");
                fetch(domainUrl + 'contracts/proceed', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + Common.getTokenData()
                    },
                    body: JSON.stringify(query_data)
                }).then((response) => response.json()).then((responseJson) => {
                    Common.reactLoader("hide");

                   
                        Common.scrollToTop();
                        this.props.getLearningRoom();
                        if (responseJson.isCompletedFully) {
                            this.props.goToThanksPage();
                        } else {
                            this.setState({
                                proceedStatus: responseJson.status
                            });
                            this.getLearningCompletedStatus();
                        }
                    

                });
            }
        });
    }
    PrintElem() {
        if(this.props.usableType=="webapp"){

            const {
                contract
            } = this.props;
            let content = "<div>" + $('#contract_content').html() + "</div>";
            let contract_btm = "<div>" + $('#signature_con').html() + "</div>";
            var mywindow = window.open('', 'PRINT', 'height=400,width=600');
            mywindow.document.write('<html><head><title>' + contract.contract_name ? contract.contract_name : '' + '</title>');
            mywindow.document.write('</head><body >');
            mywindow.document.write(content + contract_btm);
            mywindow.document.write('</body></html>');
            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/
            mywindow.print();
            mywindow.close();
            return true;
        }else{

            window.print();
        }
    }
    declineBlock() {
        this.props.declineBlock();
    }
    componentDidMount() {
        const {
            data
        } = this.props;
        if (data.status == "completed") {
            this.getLearningCompletedStatus();
            this.setState({
                proceedStatus: 2
            })
        }
    }
  render() {



   const {data,contract}=this.props;

   let LearningCompletedStatus=this.state.LearningCompletedStatus;

   let buttonSection1=null;
   let buttonSection2=null;

   if(this.state.proceedStatus==2){

    data.status='completed';

   }

   if(data.status!="completed" || this.state.proceedStatus==0){

    buttonSection1=<div id="Active">
     <div className="button">
      <input type="button" className="button-accept" onClick={e=>this.proceed()}  value={contract.button_one?contract.button_one:''} title={contract.button_one?contract.button_one:''} id="proceed" name="proceed" style={{float:'right'}} />
      <input type="button" className="button-cancel"  value={contract.button_two?contract.button_two:''} title={contract.button_two?contract.button_two:''} onClick={e=>this.declineBlock()}   id="cancel" name="cancel" style={{float:'right'}} />
     </div>

    </div>;

   }

   if(data.status=="completed" || this.state.proceedStatus==2){
     buttonSection2= <div>
        <div id="signature_con" className="contract-btm">
          <div><span className="greentxt">{contract.button_one?contract.button_one:''}</span></div>
            <div className="contract_print">
             <strong className="orgtxt">- {Username()}</strong><br />
             &nbsp; Signed on date {LearningCompletedStatus.completed_date?LearningCompletedStatus.completed_date:''}
            </div>
        </div>
        <div className="button">
         <div className="slash_txt">

          <div>
          {(this.props.usableType=="webapp")?<input type="button"  name="Print" id="Print"  value="Print this contract"  onClick={()=>this.PrintElem()} className="button-blue" alt="Print this contract" title="Print this contract" style={{float:'right'}} />:""}

          {(this.props.usableType=="webapp")?<input type="button" onClick={(e)=>this.continueTocomponentList()} name="btnsubmit" value="Continue" alt="Continue" title="Continue"  className="button_org" style={{float:'right'}} />:""}
           
          </div>
         </div>
        </div>
         </div>;
   }
    return (
     <section className="scroll" id="semana-scroll-inner">

         <section className="viewport">
            <section className="overview">
              <div className="inner-content">
               <div className="rules-regulations">
               <div id="contract_content" dangerouslySetInnerHTML={{ __html:contract.contract_content?contract.contract_content:''}} />



              <div className="clear"></div>

      <div>
       <div id="divcontract"></div>
      </div>

     <div className="thanksmsg">
       {buttonSection1}

      {buttonSection2}

       </div>

    </div>
     </div>
        </section>
      </section>
    </section>
    );
  }

}

  
function mapDispatchToProps(dispatch) {
    
    return  bindActionCreators({getLearningRoom}, dispatch);
   
}
  
export default connect(null,mapDispatchToProps)(Contentproceed);



// WEBPACK FOOTER //
// ./src/lr_dlr_components/contractpartials/Contentproceed.js